module.exports = __webpack_public_path__ + "img/nightcastle-throne.6dac8494.jpg";